// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__RpxyB","content":"Consent_content__2skt3","footer":"Consent_footer__1-BpF"};